"use client";
import { useState, useEffect } from "react";
import { Box, TextField, IconButton, InputAdornment, Stack } from "@mui/material";
import { Close, SearchOutlined } from "@mui/icons-material";
import { useSiteSearchContext } from "./SiteSearchContext";

export default function SearchFiltersSideCardSearchTextField() {
  const { search, handleSearchChange } = useSiteSearchContext();
  const [searchKey, setSearchKey] = useState(search);

  // Synchronize searchKey with search from context
  useEffect(() => {
    setSearchKey(search);
  }, [search]);

  const handleSearch = () => {
    handleSearchChange(searchKey || "");
  };

  return (
    <Box>
      <TextField
        placeholder="جستجو..."
        fullWidth
        size="small"
        margin="none"
        label="جستجو در نتایج"
        variant="filled"
        value={searchKey}
        InputProps={{
          disableUnderline: true,
          sx: (t) => ({
            backgroundColor: "transparent",
            borderRadius: 2,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            transition: "0.2s all ease",
            borderBottom: `2px solid ${t.palette.grey["400"]}`,
            "&:hover": {
              backgroundColor: "rgba(0,0,0,0.05)",
            },
            "&.Mui-focused": {
              borderRadius: 2,
              backgroundColor: "rgba(0,0,0,0.06)",
              borderBottom: `2px solid ${t.palette.secondary.main}`,
            },
          }),
          endAdornment: (
            <InputAdornment position="end">
              <Stack direction="row" display="flex" alignItems="center" justifyContent="end">
                {searchKey && (
                  <IconButton
                    size="small"
                    onClick={() => {
                      setSearchKey("");
                      handleSearchChange("");
                    }}
                    aria-label="پاک کردن جستجو"
                  >
                    <Close fontSize="small" />
                  </IconButton>
                )}
                <IconButton onClick={handleSearch} aria-label="جستجو">
                  <SearchOutlined />
                </IconButton>
              </Stack>
            </InputAdornment>
          ),
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            handleSearch();
          }
        }}
        onChange={(e) => {
          setSearchKey(e.target.value);
        }}
      />
    </Box>
  );
}
